import $ from "jquery";
import "slick-carousel";
import AOS from "aos";
import lozad from "lozad";

$(function () {
	"use strict";
	// Slick sliders

	$(".ImageCarousel").on("init", function (event, slick) {
		AOS.init();
		const observer = lozad(); // lazy loads elements with default selector as ".lozad"
		observer.observe();
	});
	$(".ImageCarousel").slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: true,
		rows: 0,
		arrows: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
					arrows: true
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: true
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: true
				}
			},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
});

// if (window.matchMedia("(max-width: 934px)").matches) {
// 	/* the viewport is less than 934 pixels wide */
// 	$("#ImageCarousel").slick({
// 		infinite: true,
// 		slidesToShow: 3,
// 		slidesToScroll: 1,
// 		dots: true,
// 		rows: 0,
// 		arrows: true,
// 		responsive: [
// 			{
// 				breakpoint: 768,
// 				settings: {
// 					slidesToShow: 2,
// 					slidesToScroll: 1,
// 					arrows: false
// 				}
// 			}
// 			// You can unslick at a given breakpoint now by adding:
// 			// settings: "unslick"
// 			// instead of a settings object
// 		]
// 	});
// }
//
// if (window.matchMedia("(max-width: 425px)").matches) {
// 	/* the viewport is less than 425 pixels wide */
// 	$("#ImageCarousel").slick({
// 		infinite: true,
// 		slidesToShow: 1,
// 		slidesToScroll: 1,
// 		rows: 0,
// 		dots: true,
// 		arrows: true,
// 	});
// }
//
// if (window.matchMedia("(min-width: 426 & max-width: 768px)").matches) {
// 	/* the viewport is less than 425 pixels wide */
// 	$("#ImageCarousel").slick({
// 		infinite: true,
// 		slidesToShow: 1,
// 		slidesToScroll: 1,
// 		rows: 0,
// 		dots: true,
// 		arrows: true,
// 	});
// }


import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";
